
import Cropper from 'cropperjs'
import base64 from 'vux/src/tools/base64/index.js'

export default {
components: {

},
computed: {
userInfo() {
return this.$store.state.userInfo
}
},
data() {
return {
headerImage: '',
picValue: '',
cropper: '',
croppable: false,
panel: false,
url: ''
}
},
mounted() {

var self = this;
var image = document.getElementById('image');
this.cropper = new Cropper(image, {
aspectRatio: 1,
viewMode: 1,
background: false,
zoomable: false,
ready: function(e) {
self.croppable = true;
console.log(e);
}
});
},
methods: {
cancel() {
let ipt = this.$refs.ipt;
ipt.value = "";
this.panel = false;
},
getObjectURL(file) {
var url = null;
if (window.createObjectURL != undefined) { // basic
url = window.createObjectURL(file);
} else if (window.URL != undefined) { // mozilla(firefox)
url = window.URL.createObjectURL(file);
} else if (window.webkitURL != undefined) { // webkit or chrome
url = window.webkitURL.createObjectURL(file);
}
return url;
},
change(e) {
let files = e.target.files || e.dataTransfer.files;
if (!files.length) return;
this.panel = true;
this.picValue = files[0];

this.url = this.getObjectURL(this.picValue);

if (this.cropper) {
this.cropper.replace(this.url);
}
this.panel = true;

},
crop() {
this.panel = false;
var croppedCanvas;
var roundedCanvas;

if (!this.croppable) {
return;
}

croppedCanvas = this.cropper.getCroppedCanvas();

roundedCanvas = this.getRoundedCanvas(croppedCanvas);

this.headerImage = roundedCanvas.toDataURL();

this.postImg()

},
getRoundedCanvas(sourceCanvas) {
var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');
var width = sourceCanvas.width;
var height = sourceCanvas.height;

canvas.width = width;
canvas.height = height;

context.imageSmoothingEnabled = true;
context.drawImage(sourceCanvas, 0, 0, width, height);
context.globalCompositeOperation = 'destination-in';
context.beginPath();
context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
context.fill();

return canvas;
},
postImg() {
let ipt = this.$refs.ipt;
ipt.value = "";
this.$store.commit('showIsLoading');
const userUploadAtt = (File, config) => this.$http.post("http://www.kmjiu.com/public/index.php/app/user/upimg.html", File, config);
var headImg = this.headerImage.replace(/\+/g, "###");
userUploadAtt(`image=${headImg}&type=base64&uuid=wsa&securitytoken=${this.$store.state.loginInfo.securitytoken}`).then(res => {
this.$store.commit('updateToast', {
show: true,
text: res.data.msg
});
});
}
},
watch: {
panel(val) {
this.$store.commit(val ? 'hideIsTab' : 'showIsTab');
}
},
props: ['img']
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/HeadPicFile/HeadPicFile.vue